import React, {useState} from "react";
import LogoWithTitle from "../lt/lt";
import {ConfirmUsername} from "@/pages/account/forgetPassword/Steps/ConfirmUsername";
import {TakePassword} from "@/pages/account/forgetPassword/Steps/TakePassword";
import {ChangePassword} from "@/pages/account/forgetPassword/Steps/ChangePassword";

const ForgetPassword = () => {
    //FAKE API
    const user = {
        username: "admin",
        password: "admin",
        sdt: "0123456789",
        email: "abc@fpt.edu.vn"
    }
    const otp = "123456";
    // END FAKE API

    const [step, setStep] = useState(1);
    //;
        return (
            <>
                <div className="flex bg-gray-50 min-h-full flex-1 flex-col justify-center px-6 py-6 lg:px-8">
                    <LogoWithTitle
                        src="/img/logo_TinViet2.jpg"
                        alt="Your Company"
                        title="Quên mật khẩu"
                    />

                    <div className="mt-2 sm:mx-auto sm:w-full sm:max-w-sm bg-white p-6 rounded-lg shadow-lg">
                        {step === 1 && (<ConfirmUsername setStep={setStep} user={user}/>)}
                        {step === 2 && (<TakePassword setStep={setStep} otp={otp}/>)}
                        {step === 3 && (<ChangePassword user={user} />)}
                    </div>
                </div>
            </>
        )
}

export default ForgetPassword;